const termsSrc = 'https://static.gotrashy.com/document.html?link='

export default class TermsUtils {
    static getSrc = (link: string) => {
        return termsSrc + link
    }

}



// WEBPACK FOOTER //
// ./src/utils/TermsUtils.ts